var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEventChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 -1 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6995 7.28645L20.7102 15.2065C21.0966 15.5885 21.0966 16.2078 20.7102 16.5897L19.7759 17.5135C19.3902 17.8948 18.7651 17.8955 18.3785 17.5151L12 11.2383L5.62147 17.5152C5.23487 17.8956 4.60978 17.8949 4.22409 17.5135L3.28976 16.5898C2.90341 16.2078 2.90341 15.5885 3.28976 15.2066L11.3005 7.28649C11.6868 6.90451 12.3132 6.90451 12.6995 7.28645Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventChevronUp);
export default __webpack_public_path__ + "static/media/EventChevronUp.a3e48c194776a5a6fa83fdf35e21f827.svg";
export { ForwardRef as ReactComponent };